import Typography from '@mui/material/Typography';
import { FormProvider } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { PATHS } from '../../config/consts';
import { PublicFormWrapper } from '../_components/PublicFormWrapper';
import { styles } from '../LoginPage/style';
import messages from './messages';
import { RegisterForm } from './RegisterForm';
import { SuccessMessage } from './SuccessMessage';
import { useRegister } from './useRegister';

export function Register() {
  const { formatMessage } = useIntl();
  const { formData, isFetching, isOryRegistrationFFEnabled, isRegistrationFinished, register } = useRegister();

  const loginLink = (
    <Typography sx={styles.subtitle}>
      <FormattedMessage
        {...messages.RegisterImsSubtitle}
        values={{
          link: (chunks) => <Link to={PATHS.LOGIN}>{chunks}</Link>,
        }}
      />
    </Typography>
  );

  return (
    <PublicFormWrapper
      title={formatMessage(messages.RegisterImsTitle, { br: <br /> })}
      subTitle={loginLink}
      hasBackgroundOffset
    >
      {isRegistrationFinished ? (
        <SuccessMessage email={formData.getValues('email')} />
      ) : (
        <FormProvider {...formData}>
          <form onSubmit={formData.handleSubmit(register)}>
            <RegisterForm isOryRegistrationFFEnabled={isOryRegistrationFFEnabled} isLoading={isFetching} />
          </form>
        </FormProvider>
      )}
    </PublicFormWrapper>
  );
}
